//
//
//
//
//
//

	export default{
		name:'loading',
		props:{
			show:{
				type:Boolean,
				default:false
			}
		},
		data(){
			return{
				
			}
		}
	}
